import React from "react"

function IconColor() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -3 16 20"><title>brush</title><g fill="#000000"><path fill="#30659B" d="M9,10L6,7l6.4-6.4c0.8-0.8,2.2-0.8,3,0l0,0c0.8,0.8,0.8,2.2,0,3L9,10z"></path> <path fill="#30659B" d="M1.4,10.3c1.2-1.2,3.1-1.2,4.2,0s1.2,3.1,0,4.2S0,16,0,16S0.2,11.5,1.4,10.3z"></path></g></svg>
  )
}

export default IconColor